const ID_TOKEN_KEY = 'ID_TOKEN_KEY'

export const getToken = () => {
  return window.localStorage.getItem(ID_TOKEN_KEY)
}

export const getLoggedInUserData = () => {
  return JSON.parse(window.localStorage.getItem('auth'))
}

export const getLoggedInUserPermissions = () => {
  return JSON.parse(window.localStorage.getItem('userPermissions'))
}

export const getHomePageMenu = () => {
  let userPermissions = JSON.parse(window.localStorage.getItem('userPermissions'))
  // console.log(userPermissions)
  let homeMenu = []
  if (userPermissions.includes('view_assign')) {
    homeMenu.push({ 'name': 'Assign' })
    homeMenu.push({ 'name': 'Bot Search' })
  }
  if (userPermissions.includes('view_waiting_docs')) {
    homeMenu.push({ 'name': 'Waiting Docs' })
  }
  if (userPermissions.includes('view_in_house')) {
    homeMenu.push({ 'name': 'In House' })
  }
  if (userPermissions.includes('view_examine')) {
    homeMenu.push({ 'name': 'Examine' })
  }
  if (userPermissions.includes('view_rejected_docs')) {
    homeMenu.push({ 'name': 'Rejected Docs' })
  }
  if (userPermissions.includes('view_data_entry')) {
    homeMenu.push({ 'name': 'Data Entry' })
  }
  if (userPermissions.includes('view_quality_assurance')) {
    homeMenu.push({ 'name': 'Q / A' })
  }
  if (userPermissions.includes('view_approved_to_send')) {
    homeMenu.push({ 'name': 'Approved To Sent' })
  }
  if (userPermissions.includes('view_quality_assurance_feedback')) {
    homeMenu.push({ 'name': 'QA Feedback' })
  }
  if (userPermissions.includes('view_send_to_client')) {
    homeMenu.push({ 'name': 'Sent' })
  }
  if (userPermissions.includes('view_on_hold')) {
    homeMenu.push({ 'name': 'On Hold' })
  }
  if (userPermissions.includes('view_client_rejected')) {
    homeMenu.push({ 'name': 'Client Rejected' })
  }
  return homeMenu
}

export const getOrderMenu = () => {
  let userPermissions = JSON.parse(window.localStorage.getItem('userPermissions'))
  // console.log(userPermissions)
  let orderMenu = []
  if (userPermissions.includes('view_assign')) {
    orderMenu.push({ 'id': 1, 'name': 'Assign', 'slug': 'assign', 'disabled': false })
  } else {
    orderMenu.push({ 'id': 1, 'name': 'Assign', 'slug': 'assign', 'disabled': true })
  }
  if (userPermissions.includes('view_in_house')) {
    orderMenu.push({ 'id': 2, 'name': 'Run Sheet UI', 'slug': 'run-seet-ui', 'disabled': false })
  } else {
    orderMenu.push({ 'id': 2, 'name': 'Run Sheet UI', 'slug': 'run-seet-ui', 'disabled': true })
  }
  if (userPermissions.includes('view_in_house')) {
    orderMenu.push({ 'id': 3, 'name': 'In House', 'slug': 'in-house', 'disabled': false })
  } else {
    orderMenu.push({ 'id': 3, 'name': 'In House', 'slug': 'in-house', 'disabled': true })
  }
  if (userPermissions.includes('view_data_entry')) {
    orderMenu.push({ 'id': 4, 'name': 'Data Entry', 'slug': 'data-entry', 'disabled': false })
  } else {
    orderMenu.push({ 'id': 4, 'name': 'Data Entry', 'slug': 'data-entry', 'disabled': true })
  }
  if (userPermissions.includes('view_quality_assurance')) {
    orderMenu.push({ 'id': 5, 'name': 'QA', 'slug': 'q-a', 'disabled': false })
  } else {
    orderMenu.push({ 'id': 5, 'name': 'QA', 'slug': 'q-a', 'disabled': true })
  }
  if (userPermissions.includes('view_quality_assurance_feedback')) {
    orderMenu.push({ 'id': 6, 'name': 'QA Feedback', 'slug': 'qa-feedback', 'disabled': false })
  } else {
    orderMenu.push({ 'id': 6, 'name': 'QA Feedback', 'slug': 'qa-feedback', 'disabled': true })
  }
  if (userPermissions.includes('view_approved_to_send')) {
    orderMenu.push({ 'id': 7, 'name': 'Approved to sent', 'slug': 'approved-to-sent', 'disabled': false })
  } else {
    orderMenu.push({ 'id': 7, 'name': 'Approved to sent', 'slug': 'approved-to-sent', 'disabled': true })
  }
  if (userPermissions.includes('view_send_to_client')) {
    orderMenu.push({ 'id': 8, 'name': 'Sent to Client', 'slug': 'sent', 'disabled': false })
  } else {
    orderMenu.push({ 'id': 8, 'name': 'Sent to Client', 'slug': 'sent', 'disabled': true })
  }
  return orderMenu
}

export const checkDownload = () => {
  let userPermissions = JSON.parse(window.localStorage.getItem('userPermissions'))
  let canDown = false
  if (userPermissions.includes('can_download')) {
    canDown = true
  }
  return canDown
}

export const addOrderCheck = () => {
  let userPermissions = JSON.parse(window.localStorage.getItem('userPermissions'))
  let canAdd = false
  if (userPermissions.includes('add_orders')) {
    canAdd = true
  }
  return canAdd
}

export const addNotesCheck = () => {
  let userPermissions = JSON.parse(window.localStorage.getItem('userPermissions'))
  let canAdd = false
  if (userPermissions.includes('add_ordernotes')) {
    canAdd = true
  }
  return canAdd
}

export const editOrderCheck = () => {
  let userPermissions = JSON.parse(window.localStorage.getItem('userPermissions'))
  let canAdd = false
  if (userPermissions.includes('change_orders')) {
    canAdd = true
  }
  return canAdd
}
export const saveToken = token => {
  window.localStorage.setItem(ID_TOKEN_KEY, token)
}

export const destroyToken = () => {
  window.localStorage.removeItem(ID_TOKEN_KEY)
  window.localStorage.removeItem('auth')
}

export const assignerCheck = () => {
  let userGroups = JSON.parse(window.localStorage.getItem('userGroups'))
  if (userGroups == null) {
    userGroups = []
  }
  let canAssign = false
  if (userGroups.includes('assigner')) {
    canAssign = true
  }
  return canAssign
}

export default { assignerCheck, getToken, saveToken, destroyToken, getLoggedInUserData, getLoggedInUserPermissions, getHomePageMenu, checkDownload, addOrderCheck, editOrderCheck, getOrderMenu, addNotesCheck }
